import { Grid, List, ListItem, ListItemText } from "@mui/material";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import React from "react";
import Blog3 from "assets/images/home-page-images/Blog3.png";

import { Container } from "@mui/material";
import Header from "../components/header";
import Footer from "../components/footer.js";
import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";
import { NavLink, useNavigate } from "react-router-dom";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import FiberManualRecordIcon from "@mui/icons-material/FiberManualRecord";
import { Helmet } from "react-helmet-async";
const Operationals = () => {
     const navigate = useNavigate();
  
  const Content = [
    {
      heading: "Manual Review Management Is Broken",
      description:
        "Running a restaurant is already demanding. Managing staff, suppliers, reservations, menus, events, and marketing doesn’t leave much time. Now you have to monitor:",
    },
  

    
  ];
  const [showButton, setShowButton] = React.useState(false);
  const [bottomOffset, setBottomOffset] = React.useState(20);
  console.log(bottomOffset, "bottom ");
  // Track scroll position
  React.useEffect(() => {
    const handleScroll = () => {
      const scrollY = window.scrollY;
      const windowHeight = window.innerHeight;
      const documentHeight = document.documentElement.scrollHeight;
      const isMobile = window.matchMedia("(max-width: 768px)").matches;
      const mobileBottomOffset = 395;
      const desktopBottomOffset = 320;

      setShowButton(scrollY > 500);

      if (windowHeight + scrollY >= documentHeight - 100) {
        setBottomOffset(isMobile ? mobileBottomOffset : desktopBottomOffset);
      } else {
        setBottomOffset(20);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const itemOne = [
    "Google Business Profile",
    "Yelp",
    "TripAdvisor",
    "Facebook Reviews",
    "Instagram comments and messages",
  ];
  const itemTwo = [
    "You miss reviews. Customers leave feedback that goes unnoticed",
    "You respond late or not at all, losing the chance to address a negative experience.",
    "You struggle to find the right words. Not every owner feels confident drafting quick and professional responses.",
    "You miss broader trends. Patterns in praise or criticism can be overlooked.",
  ];

  const itemThree = [
    "Notify you immediately when a new review appears",
    "Suggest or automatically create thoughtful, brand-consistent responses",
    "Analyze sentiment to identify common issues or positive feedback",
    "Track keyword trends (for example, “great service” versus “slow delivery”)",
    "Transform positive reviews into ready-to-use social media posts or testimonials",
  ];
  const itemFour = [
    "Plan your menu, such as stocking more iced drinks during heat waves",
    "Schedule staff for busy times",
    "Time promotions for the best impact",
  ];

  const itemFive = [
    "A customer who hasn’t visited in a month might receive a “We miss you” offer",
    "A person who always orders pasta could get a heads-up about your new Italian menu night",
    "Loyal customers may receive a birthday discount",
  ];

  const itemSix = [
    "Show you care about the guest experience",
    "Diffuse negative feelings before they escalate ",
    "Encourage satisfied customers to become loyal supporters",
  ];

  const itemSeven = [
    "Which menu items gain the most praise (or criticism)",
    "Which staff members are frequently mentioned",
    "How customer sentiment evolves over time",
    "Common words in positive versus negative reviews",
  ];

  const itemEight = [
    "An increase in your average star rating over time",
    "mplified positive reviews on your website and social media",
    "Addressing negative experiences before they damage your reputation",
    "Enhanced visibility on Google, boosting your local search rankings",
  ];

  const itemNine = [
    "Higher rankings in “restaurants near me” searches",
    "Increased foot traffic and reservations",
    "More repeat visits due to stronger customer connections",
  ];
  const itemTen = [
    "Integrates with major review sites",
    "Sends immediate alerts for new reviews",
    "Suggests or creates responses in your brand’s tone",
    "Provides sentiment analysis and keyword tracking",
    "Allows you to export positive reviews for marketing purposes",
  ];
  const itemEleven = [
    "Their Google rating climbed from 4.1 to 4.6 in four months",
    `95% of reviews were answered within 24 hours `,
    `They cut down on review management time from 6 hours weekly to 45 minutes`,
    `They identified "slow lunch service" as a recurring issue and resolved it, leading to more positive midday reviews`,
  ];

  const itemTwelve = [
    "Review AI-generated responses before posting, especially for sensitive complaints",
    "8Keep your tone genuine  AI should match your brand personality, not sound mechanical",
    "Use data for improvement, not just for damage control",
    "Engage manually every now and then to maintain a personal touch",
  ];

  const itemThirteen = [
    "Respond faster",
    "Protect and grow your brand",
    "Turn feedback into free marketing",
    "Save hours each week",
  ];
  return (
    <MDBox
      sx={{
        width: "100%",
        maxWidth: {
          xs: "100%",
          md: "1580px",
          xl: "1920px",
        },
        mx: "auto",
        // px: 2,
      }}
    >
      <Helmet>
        <title> Your Restaurant Needs an AI Review Assistant in 2026</title>
        <meta
          name="description"
          content="Boost your restaurant’s reputation in 2026 with an AI review assistant. Reply faster, improve ratings, and turn feedback into growth."
        />
        <meta name="keywords" content=" AI Review Assistant for Restaurant" />
      </Helmet>
      <Header></Header>

      <MDBox
        sx={{
          py: 3,
          mt: { xs: 4, sm: 4, md: 16 },
          mb: 4,
          zIndex: 1,
          backgroundColor: "#fff",
          position: "relative",
        }}
      >
        <MDBox
          sx={{
            position: "absolute",
            top: {
              xs: 20,
              xm: 25,
              md: 10,
            },
            left: {
              xs: 10,
              xm: 25,
              md: 50,
            },
            fontSize: {
              xs: "20px",
              xm: "40px",
              md: "40px",
            },
            color: "gray",
          }}
        >
          <MDBox 
                     onClick={() => navigate(-1)} style={{ textDecoration: "none" }}>
            <KeyboardBackspaceIcon sx={{ color: "gray", fontSize: "40px" }} />
          </MDBox>
        </MDBox>

        <Container
          sx={{
            "@media (min-width:1580px)": { maxWidth: "1600px!important" },
          }}
        >
          <Grid
            container
            spacing={0}
            sx={{
              alignItems: "center",
              width: { xs: "100%", sm: "90%", md: "90%" },
              margin: "auto",
            }}
          >
            {/* Left Side: Heading + Description */}
            <Grid
              item
              xs={6}
              md={5}
              sx={{
                mt: {
                  xs: 5,
                  sm: 0,
                  md: 0,
                },
              }}
            >
              <MDBox
                sx={{
                  width: {
                    xs: "100%",
                    sm: "90%",
                  },
                  pl: {
                    xs: 1,
                    sm: 1,
                    md: -2,
                  },

                  textAlign: "start",
                }}
              >
                <MDTypography
                  variant="h3"
                  sx={{
                    fontWeight: "600",
                    fontSize: {
                      xs: "11px",
                      md: "14px",
                      color: "#F47C00",
                      letterSpacing: 0.7,
                      fontFamily: "Poppins",
                    },
                  }}
                >
                  Trending
                </MDTypography>
                <MDTypography
                  variant="h3"
                  sx={{
                    fontWeight: 600,
                    fontSize: {
                      xs: "15px",
                      md: "38px",
                    },
                    fontFamily: "Poppins",
                    color: "#318BEC",
                  }}
                >
                  Why Your Restaurant Needs an AI Review Assistant in 2026
                </MDTypography>
                <MDTypography
                  variant="body1"
                  sx={{
                    mt: {
                      xs: 1,
                      md: 2,
                    },
                    fontSize: {
                      xs: "7px",
                      md: "14px",
                    },
                    fontWeight: 500,
                    fontFamily: "Poppins",
                    color: "#000",
                  }}
                >
                  13th August, 2025
                </MDTypography>
              </MDBox>
            </Grid>

            {/* Right Side: Image */}
            <Grid
              item
              xs={6}
              md={7}
              sx={{
                mt: {
                  xs: 4,
                  sm: 0,
                  md: 0,
                },
              }}
            >
              <MDBox sx={{ pl: "5%", pb: "4%" }}>
                <MDBox
                  component="img"
                  src={Blog3}
                  alt="AI dashboard"
                  sx={{
                    display: "block",
                    mx: "auto", // center image
                    width: {
                      xs: "215px",
                      sm: "320px",
                      md: "490px",
                      lg: "550px",
                      xl: "600px",
                    },
                    height: {
                      xs: "128px",
                      sm: "200px",
                      md: "240px",
                      lg: "300px",
                      xl: "340px",
                    },
                    borderRadius: {
                      xs: "5px",
                      sm: "16px",
                      md: "16px",
                    },
                    boxShadow: "3px 6px 20px 3px #00000066",
                  }}
                />
              </MDBox>
            </Grid>
          </Grid>
          <MDBox
            sx={{
              width: {
                xs: "95%",
                sm: "90%",
                md: "90%",
              },
              margin: "auto",
            }}
          >
            <MDTypography
              variant="body1"
              sx={{
                mt: 2,
                fontSize: {
                  xs: "10.5px",
                  sm: "14px",
                  md: "1rem",
                },
                color: "#000",
                fontFamily: "Poppins",
                textAlign: "justify",
              }}
            >
              In 2026, your restaurant’s online reputation is crucial. A single
              review can influence many potential customers, and your star
              rating can determine if people enter your establishment or move
              on.
            </MDTypography>

            <MDTypography
              variant="body1"
              sx={{
                my: 2,
                fontSize: {
                  xs: "10.5px",
                  sm: "14px",
                  md: "1rem",
                },
                fontFamily: "Poppins",
                color: "#000",
                textAlign: "justify",
              }}
            >
              Today’s diners have numerous choices. They trust platforms like
              Google, Yelp, TripAdvisor, and even Instagram comments just as
              much as personal recommendations. Research shows that <strong> 94% of
              consumers won’t visit a restaurant with a rating lower than 4
              stars, and 97% read online reviews before deciding where to go.</strong>
            </MDTypography>
            <MDTypography
              variant="body1"
              sx={{
                my: 2,
                fontSize: {
                  xs: "10.5px",
                  sm: "14px",
                  md: "1rem",
                },
                fontFamily: "Poppins",
                color: "#000",
                textAlign: "justify",
              }}
            >
              If you’re not actively managing your reviews, you’re missing out.
            </MDTypography>
            <MDTypography
              variant="body1"
              sx={{
                my: 2,
                fontSize: {
                  xs: "10.5px",
                  sm: "14px",
                  md: "1rem",
                },
                fontFamily: "Poppins",
                color: "#000",
                textAlign: "justify",
              }}
            >
              Here’s the issue:<br></br>
              Keeping track of every review, responding promptly, analyzing
              customer sentiment, and converting feedback into marketing content
              demands hours every week. This is why many smart restaurant owners
              are adopting AI-powered review assistants.
            </MDTypography>
            <MDTypography
              variant="body1"
              sx={{
                my: 2,
                fontSize: {
                  xs: "10.5px",
                  sm: "14px",
                  md: "1rem",
                },
                fontFamily: "Poppins",
                color: "#000",
                textAlign: "justify",
              }}
            >
              In this guide, we’ll explore why managing reviews is increasingly
              important, what an{" "}
              <NavLink
                style={{
                  fontFamily: "Poppins",
                  fontWeight: 400,
                  color: "blue",
                  textDecoration: "none",
                }}
                to="https://tavloai.com/"
              >
                AI review assistant{" "}
              </NavLink>{" "}
              does, and how it can affect your revenue in 2026.
            </MDTypography>

            <MDBox
              sx={{
                mb: {
                  xs: 2,
                  sm: 3,
                  md: 5,
                },
              }}
            >
              {Content.map((item, index) => (
                <MDBox key={index} mb={2}>
                  <MDTypography
                    variant="h6"
                    sx={{
                      color: "#000",
                      fontWeight: 900,
                      fontFamily: "Poppins",
                      mb: {
                        xs: 0.4,
                        sm: 3,
                        md: 3,
                      },
                      fontSize: {
                        xs: "12px",
                        sm: "14px",
                        md: "1rem",
                      },
                      fontWeight:600,
                      fontFamily: "Poppins",
                    }}
                  >
                    {item.heading}
                  </MDTypography>
                  <MDTypography
                    variant="body2"
                    sx={{
                      color: "#000",
                      fontFamily: "Poppins",
                      mb: {
                        xs: 1,
                        sm: 3,
                        md: 3,
                      },
                      fontSize: {
                        xs: "10.5px",
                        sm: "14px",
                        md: "1rem",
                      },
                      fontFamily: "Poppins",
                      textAlign: "justify",
                    }}
                  >
                    {item.description}
                  </MDTypography>
                </MDBox>
              ))}
            </MDBox>

            <List sx={{ mb: { xs: 0, sm: 1, md: 3 } }}>
              {itemOne.map((item, index) => (
                <ListItem key={index} disableGutters alignItems="flex-start">
                  <MDBox
                    sx={{
                      marginLeft: { xs: "0px", sm: "15px", md: "15px" },
                      fontSize: "6px",
                      mr: 1,
                      lineHeight: 2.2,
                      mt: {
                        xs: "5px",
                        sm: "10px",
                        md: "15px",
                      },
                    }}
                  >
                    <FiberManualRecordIcon sx={{ color: "#000" }} />
                  </MDBox>
                  <ListItemText
                    primary={item}
                    primaryTypographyProps={{
                      sx: {
                        fontFamily: "urbanist",
                        fontWeight: 400,
                        fontSize: {
                          xs: "10px",
                          sm: "14px",
                          md: "16px",
                        },
                        color: "#000",
                        fontFamily: "Poppins",
                        lineHeight: {
                          xs: 2.1,
                          sm: 2.2,
                          md: 2.2,
                        },
                      },
                    }}
                  />
                </ListItem>
              ))}
            </List>
            <MDTypography
              variant="body2"
              sx={{
                color: "#000",
                fontFamily: "Poppins",
                mb: {
                  xs: 1,
                  sm: 3,
                  md: 3,
                },
                fontSize: {
                  xs: "10.5px",
                  sm: "14px",
                  md: "1rem",
                },
                fontFamily: "Poppins",
                textAlign: "justify",
              }}
            >
              Without someone dedicated to this task, here’s what typically
              happens:
            </MDTypography>

            <List sx={{ mb: { xs: 0, sm: 1, md: 3 } }}>
              {itemTwo.map((item, index) => (
                <ListItem key={index} disableGutters alignItems="flex-start">
                  <MDBox
                    sx={{
                      marginLeft: { xs: "0px", sm: "15px", md: "15px" },
                      fontSize: "6px",
                      mr: 1,
                      lineHeight: 2.2,
                      mt: {
                        xs: "5px",
                        sm: "10px",
                        md: "15px",
                      },
                    }}
                  >
                    <FiberManualRecordIcon sx={{ color: "#000" }} />
                  </MDBox>
                  <ListItemText
                    primary={item}
                    primaryTypographyProps={{
                      sx: {
                        fontFamily: "urbanist",
                        fontWeight: 400,
                        fontSize: {
                          xs: "10px",
                          sm: "14px",
                          md: "16px",
                        },
                        color: "#000",
                        fontFamily: "Poppins",
                        lineHeight: {
                          xs: 2.1,
                          sm: 2.2,
                          md: 2.2,
                        },
                      },
                    }}
                  />
                </ListItem>
              ))}
            </List>
            <MDTypography
              variant="body2"
              sx={{
                color: "#000",
                fontFamily: "Poppins",
                mb: {
                  xs: 1,
                  sm: 3,
                  md: 3,
                },
                fontSize: {
                  xs: "10.5px",
                  sm: "14px",
                  md: "1rem",
                },
                fontFamily: "Poppins",
                textAlign: "justify",
              }}
            >
              It’s not that you don’t care. It’s simply not feasible to manage
              reviews manually in a busy restaurant.
            </MDTypography>

            <MDTypography
              variant="h1"
              sx={{
                color: "#000",
                fontFamily: "Poppins",
                mb: {
                  xs: 2,
                  sm: 3,
                  md: 5,
                },
                fontSize: {
                  xs: "14.5px",
                  sm: "14px",
                  md: "1rem",
                },
                fontFamily: "Poppins",
                textAlign: "justify",
              }}
            >
              What Is an AI Review Assistant?
            </MDTypography>
            <MDTypography
              variant="body2"
              sx={{
                color: "#000",
                fontFamily: "Poppins",
                mb: {
                  xs: 1,
                  sm: 3,
                  md: 3,
                },
                fontSize: {
                  xs: "10.5px",
                  sm: "14px",
                  md: "1rem",
                },
                fontFamily: "Poppins",
                textAlign: "justify",
              }}
            >
              An{" "}
              <NavLink
                style={{
                  fontFamily: "Poppins",
                  fontWeight: 400,
                  color: "blue",
                  textDecoration: "none",
                }}
                to="https://tavloai.com/"
              >
                AI review assistant{" "}
              </NavLink>{" "}
              is an AI-powered tool that helps you manage, respond to, and
              analyze reviews across various platforms with minimal manual
              effort.
            </MDTypography>

            <MDTypography
              variant="body2"
              sx={{
                color: "#000",
                fontFamily: "Poppins",
                mb: {
                  xs: 1,
                  sm: 3,
                  md: 3,
                },
                fontSize: {
                  xs: "10.5px",
                  sm: "14px",
                  md: "1rem",
                },
                fontFamily: "Poppins",
                textAlign: "justify",
              }}
            >
              Unlike basic tools, smart assistants like TavloAI go beyond just
              alerting you to new feedback. They:
            </MDTypography>
            <List sx={{ mb: { xs: 0, sm: 1, md: 3 } }}>
              {itemThree.map((item, index) => (
                <ListItem key={index} disableGutters alignItems="flex-start">
                  <MDBox
                    sx={{
                      marginLeft: { xs: "0px", sm: "15px", md: "15px" },
                      fontSize: "6px",
                      mr: 1,
                      lineHeight: 2.2,
                      mt: {
                        xs: "5px",
                        sm: "10px",
                        md: "15px",
                      },
                    }}
                  >
                    <FiberManualRecordIcon sx={{ color: "#000" }} />
                  </MDBox>
                  <ListItemText
                    primary={item}
                    primaryTypographyProps={{
                      sx: {
                        fontFamily: "urbanist",
                        fontWeight: 400,
                        fontSize: {
                          xs: "10px",
                          sm: "14px",
                          md: "16px",
                        },
                        color: "#000",
                        fontFamily: "Poppins",
                        lineHeight: {
                          xs: 2.1,
                          sm: 2.2,
                          md: 2.2,
                        },
                      },
                    }}
                  />
                </ListItem>
              ))}
            </List>

            <MDTypography
              variant="body2"
              sx={{
                color: "#000",
                fontFamily: "Poppins",
                mb: {
                  xs: 1,
                  sm: 3,
                  md: 3,
                },
                fontSize: {
                  xs: "10.5px",
                  sm: "14px",
                  md: "1rem",
                },
                fontFamily: "Poppins",
                textAlign: "justify",
              }}
            >
              In short, it’s like having a full-time reputation manager
              available 24/7, ensuring that no comment is missed and responding
              appropriately every time.
            </MDTypography>

            <MDTypography
              variant="h1"
              sx={{
                color: "#000",
                fontFamily: "Poppins",
                mb: {
                  xs: 1,
                  sm: 2,
                  md: 2,
                },
                fontSize: {
                  xs: "18.5px",
                  sm: "18px",
                  md: "1.5rem",
                },
                fontFamily: "Poppins",
                textAlign: "justify",
              }}
            >
              Why It Matters More Than Ever in 2026
            </MDTypography>
            <MDTypography
              variant="h1"
              sx={{
                color: "#000",
                fontFamily: "Poppins",
                mb: {
                  xs: 2,
                  sm: 3,
                  md: 5,
                },
                fontSize: {
                  xs: "14.5px",
                  sm: "14px",
                  md: "1rem",
                },
                fontFamily: "Poppins",
                textAlign: "justify",
              }}
            >
              1. Consumer Trust Starts with Reviews
            </MDTypography>
            <MDTypography
              variant="body2"
              sx={{
                color: "#000",
                fontFamily: "Poppins",
                mb: {
                  xs: 1,
                  sm: 3,
                  md: 3,
                },
                fontSize: {
                  xs: "10.5px",
                  sm: "14px",
                  md: "1rem",
                },
                fontFamily: "Poppins",
                textAlign: "justify",
              }}
            >
              For restaurants, reviews often form the first impression. Before
              potential customers encounter your menu or atmosphere, they check
              your star rating. With more people relying on mobile search in
              2026, reviews will directly impact foot traffic.
            </MDTypography>
            <MDTypography
              variant="body2"
              sx={{
                color: "#000",
                fontFamily: "Poppins",
                mb: {
                  xs: 1,
                  sm: 3,
                  md: 3,
                },
                fontSize: {
                  xs: "10.5px",
                  sm: "14px",
                  md: "1rem",
                },
                fontFamily: "Poppins",
                textAlign: "justify",
              }}
            >
              If you hold a 4.7-star rating and respond promptly to feedback,
              customers see you as reliable and attentive. In contrast, a
              3.8-star rating with unanswered complaints suggests indifference,
              even if that’s not the case.
            </MDTypography>

            <MDTypography
              variant="h1"
              sx={{
                color: "#000",
                fontFamily: "Poppins",
                mb: {
                  xs: 2,
                  sm: 3,
                  md: 5,
                },
                fontSize: {
                  xs: "14.5px",
                  sm: "14px",
                  md: "1rem",
                },
                fontFamily: "Poppins",
                textAlign: "justify",
              }}
            >
              2. AI Restaurant Marketing Is the New Standard
            </MDTypography>
            <MDTypography
              variant="body2"
              sx={{
                color: "#000",
                fontFamily: "Poppins",
                mb: {
                  xs: 1,
                  sm: 3,
                  md: 3,
                },
                fontSize: {
                  xs: "10.5px",
                  sm: "14px",
                  md: "1rem",
                },
                fontFamily: "Poppins",
                textAlign: "justify",
              }}
            >
              Many restaurants are embracing automation to remain competitive,
              from predictive menu planning to AI-driven loyalty programs.
              Review Assistant intelligence is essential in this shift.
            </MDTypography>
            <MDTypography
              variant="body2"
              sx={{
                color: "#000",
                fontFamily: "Poppins",
                mb: {
                  xs: 1,
                  sm: 3,
                  md: 3,
                },
                fontSize: {
                  xs: "10.5px",
                  sm: "14px",
                  md: "1rem",
                },
                fontFamily: "Poppins",
                textAlign: "justify",
              }}
            >
              Why? Because reviews provide free market research. They reveal
              what’s working, what’s not, and what guests value most about their
              dining experience. An AI assistant helps you collect and utilize
              this data without the hassle of spreadsheets.
            </MDTypography>

            <MDTypography
              variant="h1"
              sx={{
                color: "#000",
                fontFamily: "Poppins",
                mb: {
                  xs: 2,
                  sm: 3,
                  md: 5,
                },
                fontSize: {
                  xs: "14.5px",
                  sm: "14px",
                  md: "1rem",
                },
                fontFamily: "Poppins",
                textAlign: "justify",
              }}
            >
              3. Speed Equals Customer Retention
            </MDTypography>
            <MDTypography
              variant="body2"
              sx={{
                color: "#000",
                fontFamily: "Poppins",
                mb: {
                  xs: 1,
                  sm: 3,
                  md: 3,
                },
                fontSize: {
                  xs: "10.5px",
                  sm: "14px",
                  md: "1rem",
                },
                fontFamily: "Poppins",
                textAlign: "justify",
              }}
            >
              In our fast-paced world, diners expect immediate responses. A 2024
              survey found that replying within 24 hours can double the chances
              of a customer returning.
            </MDTypography>
            <MDTypography
              variant="body2"
              sx={{
                color: "#000",
                fontFamily: "Poppins",
                mb: {
                  xs: 1,
                  sm: 3,
                  md: 3,
                },
                fontSize: {
                  xs: "10.5px",
                  sm: "14px",
                  md: "1rem",
                },
                fontFamily: "Poppins",
                textAlign: "justify",
              }}
            >
              Quick responses:
            </MDTypography>
            <List sx={{ mb: { xs: 0, sm: 1, md: 3 } }}>
              {itemSix.map((item, index) => (
                <ListItem key={index} disableGutters alignItems="flex-start">
                  <MDBox
                    sx={{
                      marginLeft: { xs: "0px", sm: "15px", md: "15px" },
                      fontSize: "6px",
                      mr: 1,
                      lineHeight: 2.2,
                      mt: {
                        xs: "5px",
                        sm: "10px",
                        md: "15px",
                      },
                    }}
                  >
                    <FiberManualRecordIcon sx={{ color: "#000" }} />
                  </MDBox>
                  <ListItemText
                    primary={item}
                    primaryTypographyProps={{
                      sx: {
                        fontFamily: "urbanist",
                        fontWeight: 400,
                        fontSize: {
                          xs: "10px",
                          sm: "14px",
                          md: "16px",
                        },
                        color: "#000",
                        fontFamily: "Poppins",
                        lineHeight: {
                          xs: 2.1,
                          sm: 2.2,
                          md: 2.2,
                        },
                      },
                    }}
                  />
                </ListItem>
              ))}
            </List>
            <MDTypography
              variant="body2"
              sx={{
                color: "#000",
                fontFamily: "Poppins",
                mb: {
                  xs: 1,
                  sm: 3,
                  md: 3,
                },
                fontSize: {
                  xs: "10.5px",
                  sm: "14px",
                  md: "1rem",
                },
                fontFamily: "Poppins",
                textAlign: "justify",
              }}
            >
              AI assistants help ensure you respond promptly, even during peak
              hours.
            </MDTypography>

            <MDTypography
              variant="h1"
              sx={{
                color: "#000",
                fontFamily: "Poppins",
                mb: {
                  xs: 2,
                  sm: 3,
                  md: 5,
                },
                fontSize: {
                  xs: "14.5px",
                  sm: "14px",
                  md: "1rem",
                },
                fontFamily: "Poppins",
                textAlign: "justify",
              }}
            >
              4. You Get Real, Usable Insights
            </MDTypography>
            <MDTypography
              variant="body2"
              sx={{
                color: "#000",
                fontFamily: "Poppins",
                mb: {
                  xs: 1,
                  sm: 3,
                  md: 3,
                },
                fontSize: {
                  xs: "10.5px",
                  sm: "14px",
                  md: "1rem",
                },
                fontFamily: "Poppins",
                textAlign: "justify",
              }}
            >
              Reading through numerous reviews every week is time-consuming,
              making it easy to miss key patterns. Smart AI assistants can sift
              through feedback and inform you about:
            </MDTypography>

            <List sx={{ mb: { xs: 0, sm: 1, md: 3 } }}>
              {itemSeven.map((item, index) => (
                <ListItem key={index} disableGutters alignItems="flex-start">
                  <MDBox
                    sx={{
                      marginLeft: { xs: "0px", sm: "15px", md: "15px" },
                      fontSize: "6px",
                      mr: 1,
                      lineHeight: 2.2,
                      mt: {
                        xs: "5px",
                        sm: "10px",
                        md: "15px",
                      },
                    }}
                  >
                    <FiberManualRecordIcon sx={{ color: "#000" }} />
                  </MDBox>
                  <ListItemText
                    primary={item}
                    primaryTypographyProps={{
                      sx: {
                        fontFamily: "urbanist",
                        fontWeight: 400,
                        fontSize: {
                          xs: "10px",
                          sm: "14px",
                          md: "16px",
                        },
                        color: "#000",
                        fontFamily: "Poppins",
                        lineHeight: {
                          xs: 2.1,
                          sm: 2.2,
                          md: 2.2,
                        },
                      },
                    }}
                  />
                </ListItem>
              ))}
            </List>
            <MDTypography
              variant="body2"
              sx={{
                color: "#000",
                fontFamily: "Poppins",
                mb: {
                  xs: 1,
                  sm: 3,
                  md: 3,
                },
                fontSize: {
                  xs: "10.5px",
                  sm: "14px",
                  md: "1rem",
                },
                fontFamily: "Poppins",
                textAlign: "justify",
              }}
            >
              This isn’t just information; it’s a blueprint for strategies to
              enhance service, refine your menu, and guide marketing efforts.
            </MDTypography>
            <MDTypography
              variant="h1"
              sx={{
                color: "#000",
                fontFamily: "Poppins",
                mb: {
                  xs: 2,
                  sm: 3,
                  md: 5,
                },
                fontSize: {
                  xs: "14.5px",
                  sm: "14px",
                  md: "1rem",
                },
                fontFamily: "Poppins",
                textAlign: "justify",
              }}
            >
              The ROI: Better Reviews, Better Revenue
            </MDTypography>
            <MDTypography
              variant="body2"
              sx={{
                color: "#000",
                fontFamily: "Poppins",
                mb: {
                  xs: 1,
                  sm: 3,
                  md: 3,
                },
                fontSize: {
                  xs: "10.5px",
                  sm: "14px",
                  md: "1rem",
                },
                fontFamily: "Poppins",
                textAlign: "justify",
              }}
            >
              Actively managing reviews with AI assistance can result in:
            </MDTypography>

            <List sx={{ mb: { xs: 0, sm: 1, md: 3 } }}>
              {itemEight.map((item, index) => (
                <ListItem key={index} disableGutters alignItems="flex-start">
                  <MDBox
                    sx={{
                      marginLeft: { xs: "0px", sm: "15px", md: "15px" },
                      fontSize: "6px",
                      mr: 1,
                      lineHeight: 2.2,
                      mt: {
                        xs: "5px",
                        sm: "10px",
                        md: "15px",
                      },
                    }}
                  >
                    <FiberManualRecordIcon sx={{ color: "#000" }} />
                  </MDBox>
                  <ListItemText
                    primary={item}
                    primaryTypographyProps={{
                      sx: {
                        fontFamily: "urbanist",
                        fontWeight: 400,
                        fontSize: {
                          xs: "10px",
                          sm: "14px",
                          md: "16px",
                        },
                        color: "#000",
                        fontFamily: "Poppins",
                        lineHeight: {
                          xs: 2.1,
                          sm: 2.2,
                          md: 2.2,
                        },
                      },
                    }}
                  />
                </ListItem>
              ))}
            </List>
            <MDTypography
              variant="body2"
              sx={{
                color: "#000",
                fontFamily: "Poppins",
                mb: {
                  xs: 1,
                  sm: 3,
                  md: 3,
                },
                fontSize: {
                  xs: "10.5px",
                  sm: "14px",
                  md: "1rem",
                },
                fontFamily: "Poppins",
                textAlign: "justify",
              }}
            >
              Restaurants that effectively manage reviews often experience:
            </MDTypography>

            <List sx={{ mb: { xs: 0, sm: 1, md: 3 } }}>
              {itemNine.map((item, index) => (
                <ListItem key={index} disableGutters alignItems="flex-start">
                  <MDBox
                    sx={{
                      marginLeft: { xs: "0px", sm: "15px", md: "15px" },
                      fontSize: "6px",
                      mr: 1,
                      lineHeight: 2.2,
                      mt: {
                        xs: "5px",
                        sm: "10px",
                        md: "15px",
                      },
                    }}
                  >
                    <FiberManualRecordIcon sx={{ color: "#000" }} />
                  </MDBox>
                  <ListItemText
                    primary={item}
                    primaryTypographyProps={{
                      sx: {
                        fontFamily: "urbanist",
                        fontWeight: 400,
                        fontSize: {
                          xs: "10px",
                          sm: "14px",
                          md: "16px",
                        },
                        color: "#000",
                        fontFamily: "Poppins",
                        lineHeight: {
                          xs: 2.1,
                          sm: 2.2,
                          md: 2.2,
                        },
                      },
                    }}
                  />
                </ListItem>
              ))}
            </List>
            <MDTypography
              variant="body2"
              sx={{
                color: "#000",
                fontFamily: "Poppins",
                mb: {
                  xs: 1,
                  sm: 3,
                  md: 3,
                },
                fontSize: {
                  xs: "10.5px",
                  sm: "14px",
                  md: "1rem",
                },
                fontFamily: "Poppins",
                textAlign: "justify",
              }}
            >
              Additionally, since AI manages repetitive tasks, you’ll free up
              hours each week — time you can redirect to staff training, menu
              development, or improving guest experiences.
            </MDTypography>
            <MDTypography
              variant="h1"
              sx={{
                color: "#000",
                fontFamily: "Poppins",
                mb: {
                  xs: 2,
                  sm: 3,
                  md: 5,
                },
                fontSize: {
                  xs: "14.5px",
                  sm: "14px",
                  md: "1rem",
                },
                fontFamily: "Poppins",
                textAlign: "justify",
              }}
            >
              How to Implement a AI Review Assistant
            </MDTypography>
            <MDTypography
              variant="body2"
              sx={{
                color: "#000",
                fontFamily: "Poppins",
                mb: {
                  xs: 1,
                  sm: 3,
                  md: 3,
                },
                fontSize: {
                  xs: "10.5px",
                  sm: "14px",
                  md: "1rem",
                },
                fontFamily: "Poppins",
                textAlign: "justify",
              }}
            >
              Getting started is easier than you might think.
            </MDTypography>

            <MDTypography
              variant="body2"
              sx={{
                color: "#000",
                fontFamily: "Poppins",
                mb: {
                  xs: 1,
                  sm: 3,
                  md: 3,
                },
                fontSize: {
                  xs: "10.5px",
                  sm: "14px",
                  md: "1rem",
                },
                fontFamily: "Poppins",
                textAlign: "justify",
              }}
            >
              <strong>Step 1: Choose the right tool </strong> <br></br>
              Find a platform that:
            </MDTypography>

            <List sx={{ mb: { xs: 0, sm: 1, md: 3 } }}>
              {itemTen.map((item, index) => (
                <ListItem key={index} disableGutters alignItems="flex-start">
                  <MDBox
                    sx={{
                      marginLeft: { xs: "0px", sm: "15px", md: "15px" },
                      fontSize: "6px",
                      mr: 1,
                      lineHeight: 2.2,
                      mt: {
                        xs: "5px",
                        sm: "10px",
                        md: "15px",
                      },
                    }}
                  >
                    <FiberManualRecordIcon sx={{ color: "#000" }} />
                  </MDBox>
                  <ListItemText
                    primary={item}
                    primaryTypographyProps={{
                      sx: {
                        fontFamily: "urbanist",
                        fontWeight: 400,
                        fontSize: {
                          xs: "10px",
                          sm: "14px",
                          md: "16px",
                        },
                        color: "#000",
                        fontFamily: "Poppins",
                        lineHeight: {
                          xs: 2.1,
                          sm: 2.2,
                          md: 2.2,
                        },
                      },
                    }}
                  />
                </ListItem>
              ))}
            </List>
            <MDTypography
              variant="body2"
              sx={{
                color: "#000",
                fontFamily: "Poppins",
                mb: {
                  xs: 1,
                  sm: 3,
                  md: 3,
                },
                fontSize: {
                  xs: "10.5px",
                  sm: "14px",
                  md: "1rem",
                },
                fontFamily: "Poppins",
                textAlign: "justify",
              }}
            >
              <strong> Step 2: Customize your settings </strong> <br></br>
              Decide whether AI will respond automatically or draft replies for
              your approval. Set tone guidelines to maintain authenticity.
            </MDTypography>
            <MDTypography
              variant="body2"
              sx={{
                color: "#000",
                fontFamily: "Poppins",
                mb: {
                  xs: 1,
                  sm: 3,
                  md: 3,
                },
                fontSize: {
                  xs: "10.5px",
                  sm: "14px",
                  md: "1rem",
                },
                fontFamily: "Poppins",
                textAlign: "justify",
              }}
            >
              <strong> Step 3: Use the insights</strong> <br></br>
              Don’t just reply; act on the insights. If multiple reviews
              highlight long wait times, adjust your staffing. If a specific
              dessert is a hit, feature it in promotions.
            </MDTypography>

            <MDTypography
              variant="h1"
              sx={{
                color: "#000",
                fontFamily: "Poppins",
                mb: {
                  xs: 2,
                  sm: 3,
                  md: 5,
                },
                fontSize: {
                  xs: "14.5px",
                  sm: "14px",
                  md: "1rem",
                },
                fontFamily: "Poppins",
                textAlign: "justify",
              }}
            >
              Real-World Example: A Bistro That Turned Reviews into Growth
            </MDTypography>
            <MDTypography
              variant="body2"
              sx={{
                color: "#000",
                fontFamily: "Poppins",
                mb: {
                  xs: 1,
                  sm: 3,
                  md: 3,
                },
                fontSize: {
                  xs: "10.5px",
                  sm: "14px",
                  md: "1rem",
                },
                fontFamily: "Poppins",
                textAlign: "justify",
              }}
            >
              A family-owned bistro in a bustling downtown struggled with
              managing reviews. They received an average of 15–20 reviews weekly
              but only responded to a few.
            </MDTypography>

            <MDTypography
              variant="body2"
              sx={{
                color: "#000",
                fontFamily: "Poppins",
                mb: {
                  xs: 1,
                  sm: 3,
                  md: 3,
                },
                fontSize: {
                  xs: "10.5px",
                  sm: "14px",
                  md: "1rem",
                },
                fontFamily: "Poppins",
                textAlign: "justify",
              }}
            >
              After implementing TavloAI:
            </MDTypography>

            <List sx={{ mb: { xs: 0, sm: 1, md: 3 } }}>
              {itemEleven.map((item, index) => (
                <ListItem key={index} disableGutters alignItems="flex-start">
                  <MDBox
                    sx={{
                      marginLeft: { xs: "0px", sm: "15px", md: "15px" },
                      fontSize: "6px",
                      mr: 1,
                      lineHeight: 2.2,
                      mt: {
                        xs: "5px",
                        sm: "10px",
                        md: "15px",
                      },
                    }}
                  >
                    <FiberManualRecordIcon sx={{ color: "#000" }} />
                  </MDBox>
                  <ListItemText
                    primary={item}
                    primaryTypographyProps={{
                      sx: {
                        fontFamily: "urbanist",
                        fontWeight: 400,
                        fontSize: {
                          xs: "10px",
                          sm: "14px",
                          md: "16px",
                        },
                        color: "#000",
                        fontFamily: "Poppins",
                        lineHeight: {
                          xs: 2.1,
                          sm: 2.2,
                          md: 2.2,
                        },
                      },
                    }}
                  />
                </ListItem>
              ))}
            </List>
            <MDTypography
              variant="body2"
              sx={{
                color: "#000",
                fontFamily: "Poppins",
                mb: {
                  xs: 1,
                  sm: 3,
                  md: 3,
                },
                fontSize: {
                  xs: "10.5px",
                  sm: "14px",
                  md: "1rem",
                },
                fontFamily: "Poppins",
                textAlign: "justify",
              }}
            >
              The owner even started reposting excellent reviews on Instagram
              Stories, which boosted engagement and bookings.
            </MDTypography>

            <MDTypography
              variant="h1"
              sx={{
                color: "#000",
                fontFamily: "Poppins",
                mb: {
                  xs: 2,
                  sm: 3,
                  md: 5,
                },
                fontSize: {
                  xs: "14.5px",
                  sm: "14px",
                  md: "1rem",
                },
                fontFamily: "Poppins",
                textAlign: "justify",
              }}
            >
              What to Avoid When Using AI Review Assistants
            </MDTypography>

            <MDTypography
              variant="body2"
              sx={{
                color: "#000",
                fontFamily: "Poppins",
                mb: {
                  xs: 1,
                  sm: 3,
                  md: 3,
                },
                fontSize: {
                  xs: "10.5px",
                  sm: "14px",
                  md: "1rem",
                },
                fontFamily: "Poppins",
                textAlign: "justify",
              }}
            >
              While automation is powerful, remember to:
            </MDTypography>

            <List sx={{ mb: { xs: 0, sm: 1, md: 3 } }}>
              {itemTwelve.map((item, index) => (
                <ListItem key={index} disableGutters alignItems="flex-start">
                  <MDBox
                    sx={{
                      marginLeft: { xs: "0px", sm: "15px", md: "15px" },
                      fontSize: "6px",
                      mr: 1,
                      lineHeight: 2.2,
                      mt: {
                        xs: "5px",
                        sm: "10px",
                        md: "15px",
                      },
                    }}
                  >
                    <FiberManualRecordIcon sx={{ color: "#000" }} />
                  </MDBox>
                  <ListItemText
                    primary={item}
                    primaryTypographyProps={{
                      sx: {
                        fontFamily: "urbanist",
                        fontWeight: 400,
                        fontSize: {
                          xs: "10px",
                          sm: "14px",
                          md: "16px",
                        },
                        color: "#000",
                        fontFamily: "Poppins",
                        lineHeight: {
                          xs: 2.1,
                          sm: 2.2,
                          md: 2.2,
                        },
                      },
                    }}
                  />
                </ListItem>
              ))}
            </List>
            <MDTypography
              variant="h1"
              sx={{
                color: "#000",
                fontFamily: "Poppins",
                mb: {
                  xs: 2,
                  sm: 3,
                  md: 5,
                },
                fontSize: {
                  xs: "14.5px",
                  sm: "14px",
                  md: "1rem",
                },
                fontFamily: "Poppins",
                textAlign: "justify",
              }}
            >
              Final Thoughts: Your Reputation Is Your Best Marketing
            </MDTypography>

            <MDTypography
              variant="body2"
              sx={{
                color: "#000",
                fontFamily: "Poppins",
                mb: {
                  xs: 1,
                  sm: 3,
                  md: 3,
                },
                fontSize: {
                  xs: "10.5px",
                  sm: "14px",
                  md: "1rem",
                },
                fontFamily: "Poppins",
                textAlign: "justify",
              }}
            >
              In 2026, your reputation is your strongest marketing tool.
              Customers trust one another more than ads, and your online reviews
              publicly reflect how well you meet expectations.
            </MDTypography>
            <MDTypography
              variant="body2"
              sx={{
                color: "#000",
                fontFamily: "Poppins",
                mb: {
                  xs: 1,
                  sm: 3,
                  md: 3,
                },
                fontSize: {
                  xs: "10.5px",
                  sm: "14px",
                  md: "1rem",
                },
                fontFamily: "Poppins",
                textAlign: "justify",
              }}
            >
              With an{" "}
              <NavLink
                style={{
                  fontFamily: "Poppins",
                  fontWeight: 400,
                  color: "blue",
                  textDecoration: "none",
                }}
                to="https://tavloai.com/"
              >
                AI review assistant{" "}
              </NavLink>
              like TavloAI, you can:
            </MDTypography>
            <List sx={{ mb: { xs: 0, sm: 1, md: 3 } }}>
              {itemThirteen.map((item, index) => (
                <ListItem key={index} disableGutters alignItems="flex-start">
                  <MDBox
                    sx={{
                      marginLeft: { xs: "0px", sm: "15px", md: "15px" },
                      fontSize: "6px",
                      mr: 1,
                      lineHeight: 2.2,
                      mt: {
                        xs: "5px",
                        sm: "10px",
                        md: "15px",
                      },
                    }}
                  >
                    <FiberManualRecordIcon sx={{ color: "#000" }} />
                  </MDBox>
                  <ListItemText
                    primary={item}
                    primaryTypographyProps={{
                      sx: {
                        fontFamily: "urbanist",
                        fontWeight: 400,
                        fontSize: {
                          xs: "10px",
                          sm: "14px",
                          md: "16px",
                        },
                        color: "#000",
                        fontFamily: "Poppins",
                        lineHeight: {
                          xs: 2.1,
                          sm: 2.2,
                          md: 2.2,
                        },
                      },
                    }}
                  />
                </ListItem>
              ))}
            </List>

            <MDTypography
              variant="body2"
              sx={{
                color: "#000",
                fontFamily: "Poppins",
                mb: {
                  xs: 1,
                  sm: 3,
                  md: 3,
                },
                fontSize: {
                  xs: "10.5px",
                  sm: "14px",
                  md: "1rem",
                },
                fontFamily: "Poppins",
                textAlign: "justify",
              }}
            >
              The tools are available, the process is straightforward, and the
              benefits are tangible.
            </MDTypography>

            <MDTypography
              variant="body2"
              sx={{
                color: "#000",
                fontFamily: "Poppins",
                mb: {
                  xs: 1,
                  sm: 3,
                  md: 3,
                },
                fontSize: {
                  xs: "10.5px",
                  sm: "14px",
                  md: "1rem",
                },
                fontFamily: "Poppins",
                textAlign: "justify",
              }}
            >
              <NavLink
                style={{
                  fontFamily: "Poppins",
                  fontWeight: 400,
                  color: "blue",
                  textDecoration: "none",
                }}
                to="https://tavloai.com/register"
              >
                {" "}
                Start your free trial today
              </NavLink>{" "}
              to see how{" "}
              <NavLink
                style={{
                  fontFamily: "Poppins",
                  fontWeight: 400,
                  color: "blue",
                  textDecoration: "none",
                }}
                to="https://tavloai.com/contact"
              >
                TavloAI
              </NavLink>{" "}
              converts customer feedback into real business results without
              adding to your workload.
            </MDTypography>
          </MDBox>
        </Container>

        {showButton && (
        <MDBox
          sx={{
            position: "fixed",
            bottom: bottomOffset,
            right: { xs: 20, md: 35 },
            zIndex: 9999,
          }}
        >
          <MDBox
            onClick={scrollToTop}
            sx={{
              cursor: "pointer",
              p: { xs: 0.5, md: 1 },
              backgroundColor: "#F47C00",
              borderRadius: "50%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              fontSize: "30px"
            }}
          >
            <ArrowUpwardIcon sx={{ color: "#fff", fontSize: "30px" }} />
          </MDBox>
        </MDBox>
      )}
      </MDBox>
      <Footer></Footer>
    </MDBox>
  );
};

export default Operationals;
